<template>
  <div>
    <main>
      <pricing-grid/>
    </main>

    <footerComponent></footerComponent>
  </div>
</template>

<script>
import footerComponent from "@/components/footerComponent.vue";
import PricingGrid from "../components/PricingGrid.vue";

export default {
  name: "Pricing",

  components: {
    PricingGrid,
    footerComponent,
  },
};
</script>